import React from 'react'
import { useRouter } from 'next/router'

import Layout from 'components/shared/Layout'
import CardsGrid from 'components/shared/CardsGrid'
import ListCardContent from 'components/shared/CardWithArrowLink/ListCardContent'
import { CardWithArrowLinkProps } from 'components/shared/CardWithArrowLink'

const IntegrationTopics = ({ topics, integration }) => {
  const router = useRouter()
  const currentUrl = router.asPath

  const customCardProps = CardWithArrowLinkProps.customCardProps
  return (
    <Layout tag="section" type="maxWidth">
      <Layout type="wrapper">
        <CardsGrid
          cards={topics?.data.map((topic) => {
            return {
              ...topic?.attributes,
              link: {
                href: `${currentUrl}/topics/${topic?.attributes?.slug}`,
              },
            }
          })}
          resize
          customCardComponent={ListCardContent}
          customCardProps={{ ...customCardProps, cover: { size: 'large' } }}
        />
      </Layout>
    </Layout>
  )
}

IntegrationTopics.defaultProps = {}

export default IntegrationTopics
